import {isNodeTesting} from 'lib/Browser';

import {arePlotSuggestionsSupported} from './SuggestPlotsConstants';

const LLM_ENABLE_SUGGESTED_PLOTS_FLAG = 'LLM_ENABLE_SUGGESTED_PLOTS';

let cachedSupportedResult: boolean | null = null;

export function arePlotSuggestionsSupportedSync(): boolean {
  if (cachedSupportedResult != null) {
    return cachedSupportedResult;
  }
  let flagValue = false;
  if (!isNodeTesting && window.ldClient?.ready) {
    flagValue = window.ldClient.variation(LLM_ENABLE_SUGGESTED_PLOTS_FLAG, false) === true;
  }
  const result = arePlotSuggestionsSupported(flagValue);
  if (!isNodeTesting && window.ldClient?.ready) {
    cachedSupportedResult = result;
  }
  return result;
}

export function resetPlotSuggestionsSupportedCache(): void {
  cachedSupportedResult = null;
}
